const OUTCOMES = [
  { icon: "⚡", title: "Reduce manual work",            n: "−60%", label: "routine tasks automated" },
  { icon: "📈", title: "Improve sales conversion",       n: "+38%", label: "lead-to-close rate" },
  { icon: "🕑", title: "Deliver 24/7 customer support",  n: "24/7", label: "always-on AI" },
  { icon: "💰", title: "Reduce operational costs",       n: "−30%", label: "opex headcount-adjusted" },
  { icon: "📄", title: "Speed up document processing",   n: "10×",  label: "faster than humans" },
  { icon: "🧭", title: "Improve decision-making",        n: "Real", label: "time predictive insights" },
  { icon: "🚀", title: "Scale without increasing headcount", n: "0 hires", label: "to 2× capacity" },
];

const BusinessOutcomes = () => (
  <section id="outcomes" className="section bg-warm" data-bg="cream" data-testid="outcomes-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Business outcomes</span>
        <h2 className="section-h2">
          What businesses achieve<br />
          <span className="serif">with Aria</span>.
        </h2>
        <p className="section-sub">
          Aria's customers don't measure success in features deployed. They
          measure it in rupees recovered, hours given back, and decisions made faster.
        </p>
      </div>

      <div className="outcomes-grid reveal">
        {OUTCOMES.map((o, i) => (
          <article key={i} className="outcome-card" data-testid={`outcome-${i}`}>
            <div className="outcome-icon">{o.icon}</div>
            <div className="outcome-num">{o.n}</div>
            <div className="outcome-label">{o.label}</div>
            <h3 className="outcome-title">{o.title}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default BusinessOutcomes;
